/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateMarketMakerOptions,
  UpdateMarketMakerStatus200,
  UpdateMarketMakerStatus400,
  UpdateMarketMakerStatus401,
  UpdateMarketMakerStatus403,
  UpdateMarketMakerStatus404,
  UpdateMarketMakerStatus409,
  UpdateMarketMakerStatus500,
} from '../types/UpdateMarketMaker'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateMarketMaker } from '../clients/updateMarketMaker'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateMarketMakerMutationKey = () => [{ url: '/v1/market-makers' }] as const

export function updateMarketMakerMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateMarketMakerMutationKey()
  return mutationOptions<
    UpdateMarketMakerStatus200,
    ResponseErrorConfig<
      | UpdateMarketMakerStatus400
      | UpdateMarketMakerStatus401
      | UpdateMarketMakerStatus403
      | UpdateMarketMakerStatus404
      | UpdateMarketMakerStatus409
      | UpdateMarketMakerStatus500
    >,
    UpdateMarketMakerOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return updateMarketMaker({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Replace MM configuration and assigned order books atomically
 * {@link /v1/market-makers}
 */
export function useUpdateMarketMaker<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateMarketMakerStatus200,
      ResponseErrorConfig<
        | UpdateMarketMakerStatus400
        | UpdateMarketMakerStatus401
        | UpdateMarketMakerStatus403
        | UpdateMarketMakerStatus404
        | UpdateMarketMakerStatus409
        | UpdateMarketMakerStatus500
      >,
      UpdateMarketMakerOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateMarketMakerMutationKey()

  const baseOptions = updateMarketMakerMutationOptions(config) as UseMutationOptions<
    UpdateMarketMakerStatus200,
    ResponseErrorConfig<
      | UpdateMarketMakerStatus400
      | UpdateMarketMakerStatus401
      | UpdateMarketMakerStatus403
      | UpdateMarketMakerStatus404
      | UpdateMarketMakerStatus409
      | UpdateMarketMakerStatus500
    >,
    UpdateMarketMakerOptions,
    TContext
  >

  return useMutation<
    UpdateMarketMakerStatus200,
    ResponseErrorConfig<
      | UpdateMarketMakerStatus400
      | UpdateMarketMakerStatus401
      | UpdateMarketMakerStatus403
      | UpdateMarketMakerStatus404
      | UpdateMarketMakerStatus409
      | UpdateMarketMakerStatus500
    >,
    UpdateMarketMakerOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateMarketMakerStatus200,
    ResponseErrorConfig<
      | UpdateMarketMakerStatus400
      | UpdateMarketMakerStatus401
      | UpdateMarketMakerStatus403
      | UpdateMarketMakerStatus404
      | UpdateMarketMakerStatus409
      | UpdateMarketMakerStatus500
    >,
    UpdateMarketMakerOptions,
    TContext
  >
}
